import React from "react";

const InBusketIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
    >
      <path
        d="M21.5468 6.65918H23.2724L24.998 22.3288C25.0306 22.6644 24.6562 22.9537 24.184 22.9537L1.81595 23C1.34384 23 0.969415 22.7107 1.00197 22.3751L2.59735 6.70548H4.38812"
        stroke="#0D006C"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0347 7.89746H10.916"
        stroke="#0D006C"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.2911 9.80694V4.86532C18.2911 2.72434 15.9142 1 12.9839 1C10.0536 1 7.67676 2.73592 7.67676 4.86532V9.80694"
        stroke="#0D006C"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4773 18.4034V12.7784H13.4318V18.4034H12.4773ZM10.142 16.0682V15.1136H15.767V16.0682H10.142Z"
        fill="#0D006C"
      />
    </svg>
  );
};

export default InBusketIcon;
